<sb-dialog-header class="grid grid-cols-1 children:col-start-1 children:row-start-1">
  @if (isAnimation) {
    <div class="flex items-center justify-center overflow-hidden rounded-lg bg-success-subtle">
      <canvas [sbRiveAnimation]="assetPath" width="160" height="160"></canvas>
    </div>
  } @else {
    <div
      class="aspect-8/3 items-center justify-center overflow-hidden rounded-lg border-2 border-solid border-grey-200 bg-grey-200/25 bg-cover bg-center bg-no-repeat"
      [ngStyle]="{
        'background-image': 'url(' + assetPath + ')'
      }"
    ></div>
  }
</sb-dialog-header>

<sb-dialog-content>
  <h3 sb-dialog-title class="mb-4">{{ title }}</h3>
  @switch (data.step) {
    @case (OnboardingDialogStep.FINISH_INVITED) {
      <p>
        {{
          'Your team invites are on the way! In the meantime, keep building your schedule and explore Shiftbase. For help, check out our Quick Start Guide. Happy scheduling!'
            | translate
        }}
      </p>
    }
    @case (OnboardingDialogStep.FINISH_INVITES_SKIPPED) {
      <p>
        {{
          "You've completed the tour and your setup is well on its way. Take your time exploring the app and continue building your schedule. For any help along the way, check out our Quick Start Guide. Enjoy managing your team with ease!"
            | translate
        }}
      </p>
    }
  }
</sb-dialog-content>

<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    @if (secondary && secondary.type === 'link') {
      <a sb-button [color]="'secondary'" [href]="secondary.link" target="_blank">
        {{ secondary.text }}
      </a>
    } @else if (secondary && secondary.type === 'text') {
      <button sb-button [color]="'secondary'" (click)="onSecondaryClick()">
        {{ secondary.text }}
      </button>
    }
    <button sb-button [color]="'primary'" (click)="onPrimaryClick()">
      {{ primary }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
